import React from 'react';
import DealerLogoUpload from './dealerLogo/DealerLogoUpload';

export const GlobalPrintingSettings: React.FC = () => <DealerLogoUpload />;

export default GlobalPrintingSettings;
